<template>
    <SvgLine
        v-if="type === 'line'"
        :area="area"
        :smooth="smooth"
        :circle="circle"
        :radius="radius"
        :autoDraw="autoDraw"
        :autoDrawDuration="autoDrawDuration"
        :autoDrawEasing="autoDrawEasing"
        :data="data"
        :xKey="xKey"
        :yKeys="yKeys"
        :tickPadding="tickPadding"
        :tickSize="tickSize"
        :padding="padding"
        :marginLeft="marginLeft"
        :gradients="gradients"
        :gradient="gradient"
        :gradientDirection="gradientDirection"
        :height="height"
        :width="width"
        :labelRotate="labelRotate"
        :strokeWidth="strokeWidth"
        :xAxis="xAxis"
        :yAxis="yAxis"
        :xLabel="xLabel"
        :yLabel="yLabel"
        :xGrid="xGrid"
        :yGrid="yGrid"
        :minimumMax="minimumMax"
        :maximumMax="maximumMax"
        :legendSize="legendSize"
        :legendPadding="legendPadding"
        :legendDirection="legendDirection"
        @mouseover:point="$listeners['mouseover:point']"
        @mouseout:point="$listeners['mouseout:point']"
        @select:range="$listeners['select:range']"
    >
        <template v-slot:x-axis="{ item }">
            <slot name="x-axis" :item="{ ...item }"></slot>
        </template>
        <template v-slot:y-axis="{ item }">
            <slot :item="{ ...item }" name="y-axis"></slot>
        </template>
    </SvgLine>
    <SvgBar
        v-else-if="type === 'bar'"
        :multiOffset="multiOffset"
        :stacked="stacked"
        :growDurations="growDurations"
        :minBarHeight="minBarHeight"
        :barColors="barColors"
        :noneColor="noneColor"
        :rounding="rounding"
        :barPaddingRate="barPaddingRate"
        :barLabelPadding="barLabelPadding"
        :barShadowFilter="barShadowFilter"
        :barLabel="barLabel"
        :data="data"
        :xKey="xKey"
        :yKeys="yKeys"
        :tickPadding="tickPadding"
        :tickSize="tickSize"
        :padding="padding"
        :marginLeft="marginLeft"
        :gradients="gradients"
        :gradient="gradient"
        :gradientDirection="gradientDirection"
        :height="height"
        :width="width"
        :labelRotate="labelRotate"
        :strokeWidth="strokeWidth"
        :xAxis="xAxis"
        :yAxis="yAxis"
        :xLabel="xLabel"
        :yLabel="yLabel"
        :xGrid="xGrid"
        :yGrid="yGrid"
        :minimumMax="minimumMax"
        :maximumMax="maximumMax"
        :legendSize="legendSize"
        :legendPadding="legendPadding"
        :legendDirection="legendDirection"
        @mouseover:point="$listeners['mouseover:point']"
        @mouseout:point="$listeners['mouseout:point']"
    >
    </SvgBar>
</template>

<script>
import SvgLine from './components/SvgLine'
import SvgBar from './components/SvgBar'
import commonProps from './mixins/commonProps'
import lineProps from './mixins/lineProps'
import barProps from './mixins/barProps'
export default {
    components: {
        SvgLine,
        SvgBar
    },
    mixins: [
        commonProps,
        lineProps,
        barProps
    ],
    props: {
        type: String
    }
}
</script>

<style lang="scss" scoped>

</style>
